export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  duration: string;
  quality: string;
  views: number;
  rating: number;
  description: string;
  releaseDate: string;
  source: string;
}

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
}

export const videoCategories: CategoryItem[] = [
  { slug: 'zuixin', name: '最新上线', icon: 'ri-flashlight-line' },
  { slug: 'remen', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'hongtao', name: '红桃视频', icon: 'ri-heart-line' },
  { slug: 'yingtao', name: '樱桃视频', icon: 'ri-star-line' },
  { slug: 'qiezi', name: '茄子视频', icon: 'ri-movie-line' },
  { slug: 'tangxin', name: '糖心视频', icon: 'ri-hearts-line' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '春日的私语',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20film%20poster%20style%20image%2C%20soft%20warm%20lighting%2C%20cherry%20blossom%20petals%20falling%2C%20elegant%20composition%2C%20cinematic%20atmosphere%2C%20pink%20and%20cream%20color%20palette%2C%20dreamy%20aesthetic%2C%20emotional%20portrait%20photography%20style&width=600&height=800&seq=video-cover-001&orientation=portrait',
    category: 'hongtao',
    tags: ['爱情', '剧情', '治愈'],
    duration: '1:48:23',
    quality: '1080P',
    views: 128500,
    rating: 8.7,
    description: '一部温暖治愈的爱情故事，讲述两个年轻人在樱花盛开的季节相遇、相知、相爱的动人旅程。画面唯美，情感真挚，带你感受春日里最纯粹的爱情。',
    releaseDate: '2026-07-15',
    source: '红桃视频',
  },
  {
    id: 'v002',
    title: '暗夜追踪',
    cover: 'https://readdy.ai/api/search-image?query=A%20suspense%20thriller%20movie%20poster%2C%20dark%20city%20alley%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20mysterious%20silhouette%2C%20film%20noir%20style%2C%20dramatic%20shadows%2C%20cinematic%20photography&width=600&height=800&seq=video-cover-002&orientation=portrait',
    category: 'yingtao',
    tags: ['悬疑', '犯罪', '动作'],
    duration: '2:05:47',
    quality: '4K',
    views: 256300,
    rating: 9.1,
    description: '顶级犯罪悬疑大片，跟随硬汉警探深入城市最黑暗的角落，揭开一连串离奇案件背后的惊人真相。节奏紧凑，反转不断，让你屏息看完每一分钟。',
    releaseDate: '2026-07-20',
    source: '樱桃视频',
  },
  {
    id: 'v003',
    title: '美食环游记',
    cover: 'https://readdy.ai/api/search-image?query=A%20food%20travel%20documentary%20poster%2C%20colorful%20Chinese%20cuisine%20dishes%20arranged%20beautifully%2C%20warm%20kitchen%20atmosphere%2C%20steaming%20hot%20food%2C%20appetizing%20composition%2C%20rich%20colors%2C%20gourmet%20photography%20style&width=600&height=800&seq=video-cover-003&orientation=portrait',
    category: 'zongyi',
    tags: ['美食', '旅行', '真人秀'],
    duration: '0:58:12',
    quality: '1080P',
    views: 89200,
    rating: 8.4,
    description: '跟随美食达人走遍中国大街小巷，探寻最地道的地方美食。从四川火锅到广东早茶，每一集都是一场味蕾的冒险之旅。',
    releaseDate: '2026-07-18',
    source: '糖心视频',
  },
  {
    id: 'v004',
    title: '星际征途：新纪元',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20movie%20poster%20with%20spaceship%20flying%20through%20colorful%20nebula%2C%20distant%20planets%2C%20epic%20scale%2C%20futuristic%20design%2C%20cinematic%20space%20photography%2C%20dramatic%20lighting%2C%20adventure%20theme&width=600&height=800&seq=video-cover-004&orientation=portrait',
    category: 'dianying',
    tags: ['科幻', '冒险', '特效'],
    duration: '2:22:08',
    quality: '4K',
    views: 421000,
    rating: 9.3,
    description: '年度最受期待的科幻巨制！人类星际殖民舰队在遥远星系遭遇未知文明，一场关乎人类命运的史诗对决即将展开。视觉特效震撼，故事格局宏大。',
    releaseDate: '2026-08-01',
    source: '茄子视频',
  },
  {
    id: 'v005',
    title: '职场风云录',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20office%20drama%20TV%20series%20poster%2C%20young%20professionals%20in%20business%20attire%2C%20glass%20skyscraper%20background%2C%20corporate%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20photography%20style&width=600&height=800&seq=video-cover-005&orientation=portrait',
    category: 'dianshiju',
    tags: ['都市', '职场', '励志'],
    duration: '45:30',
    quality: '1080P',
    views: 156700,
    rating: 8.2,
    description: '聚焦当代都市职场人的奋斗与成长，真实还原互联网大厂的职场生态。有欢笑有泪水，有拼搏有妥协，每一集都是打工人的真实写照。',
    releaseDate: '2026-07-22',
    source: '红桃视频',
  },
  {
    id: 'v006',
    title: '灵境传说',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20anime%20poster%20with%20magical%20creatures%20and%20ancient%20Chinese%20architecture%2C%20floating%20temples%2C%20ethereal%20glowing%20spirits%2C%20mythical%20atmosphere%2C%20vibrant%20colors%2C%20illustration%20art%20style&width=600&height=800&seq=video-cover-006&orientation=portrait',
    category: 'dongman',
    tags: ['奇幻', '仙侠', '国漫'],
    duration: '0:24:18',
    quality: '4K',
    views: 334200,
    rating: 9.5,
    description: '国漫巅峰之作！讲述少年在仙侠世界中修炼成长、斩妖除魔的热血冒险。精美的画面、宏大的世界观、感人的故事，每一帧都是壁纸级别的视觉享受。',
    releaseDate: '2026-07-25',
    source: '樱桃视频',
  },
  {
    id: 'v007',
    title: '深夜图书馆',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20library%20at%20night%20with%20warm%20candlelight%2C%20old%20books%2C%20dust%20particles%20in%20light%20beams%2C%20atmospheric%20horror%20theme%2C%20dark%20academia%20aesthetic%2C%20cinematic%20photography&width=600&height=800&seq=video-cover-007&orientation=portrait',
    category: 'qiezi',
    tags: ['恐怖', '悬疑', '心理'],
    duration: '1:35:42',
    quality: '1080P',
    views: 98700,
    rating: 8.0,
    description: '一所古老图书馆中隐藏着不为人知的秘密，午夜时分总有诡异的声音回荡。一群大学生意外揭开了尘封百年的诅咒，恐怖之旅就此开启。',
    releaseDate: '2026-07-28',
    source: '茄子视频',
  },
  {
    id: 'v008',
    title: '甜蜜的家',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20family%20drama%20poster%2C%20happy%20family%20in%20cozy%20living%20room%2C%20soft%20natural%20light%20through%20windows%2C%20plants%20and%20books%2C%20heartwarming%20atmosphere%2C%20lifestyle%20photography%20style&width=600&height=800&seq=video-cover-008&orientation=portrait',
    category: 'tangxin',
    tags: ['家庭', '温情', '喜剧'],
    duration: '1:52:30',
    quality: '1080P',
    views: 67200,
    rating: 8.5,
    description: '温馨感人的家庭喜剧，讲述三代同堂的大家庭在日常生活中发生的趣事与感动。笑中带泪，让人在欢笑中感受到家的温暖与珍贵。',
    releaseDate: '2026-07-30',
    source: '糖心视频',
  },
  {
    id: 'v009',
    title: '极限巅峰',
    cover: 'https://readdy.ai/api/search-image?query=A%20mountain%20climbing%20adventure%20film%20poster%2C%20snow-capped%20peaks%2C%20dramatic%20landscape%2C%20climbers%20on%20steep%20ridge%2C%20golden%20sunset%20light%2C%20epic%20adventure%20photography%2C%20survival%20theme&width=600&height=800&seq=video-cover-009&orientation=portrait',
    category: 'dianying',
    tags: ['冒险', '运动', '励志'],
    duration: '2:08:15',
    quality: '4K',
    views: 189300,
    rating: 8.9,
    description: '根据真实事件改编的登山冒险大片。一支业余登山队挑战世界最危险山峰，在极端环境下展现人类不屈不挠的意志力。震撼人心的画面，感人至深的故事。',
    releaseDate: '2026-07-12',
    source: '红桃视频',
  },
  {
    id: 'v010',
    title: '笑傲江湖之风云再起',
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20TV%20series%20poster%2C%20ancient%20Chinese%20warriors%20with%20swords%2C%20misty%20mountains%2C%20flowing%20robes%2C%20dramatic%20fight%20scene%2C%20epic%20wuxia%20cinematography%2C%20golden%20and%20red%20color%20scheme&width=600&height=800&seq=video-cover-010&orientation=portrait',
    category: 'dianshiju',
    tags: ['武侠', '古装', '动作'],
    duration: '48:20',
    quality: '4K',
    views: 567800,
    rating: 9.4,
    description: '改编自经典武侠巨著的全新力作！江湖风云变幻，英雄辈出，一段段恩怨情仇在刀光剑影中徐徐展开。顶级演员阵容，精良制作，引爆武侠热潮。',
    releaseDate: '2026-08-01',
    source: '樱桃视频',
  },
  {
    id: 'v011',
    title: '萌宠大作战',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20animated%20movie%20poster%20with%20adorable%20cartoon%20animals%2C%20colorful%20playful%20style%2C%20happy%20vibrant%20colors%2C%20family%20friendly%20animation%2C%20fun%20adventure%20theme%2C%20illustration%20art&width=600&height=800&seq=video-cover-011&orientation=portrait',
    category: 'dongman',
    tags: ['动画', '喜剧', '合家欢'],
    duration: '1:35:00',
    quality: '1080P',
    views: 145600,
    rating: 8.3,
    description: '全家人一起看的欢乐动画！一群可爱的小动物为了拯救家园，踏上了一场奇幻冒险之旅。画面精美，角色萌趣，笑点密集，大人小孩都会爱上。',
    releaseDate: '2026-07-16',
    source: '茄子视频',
  },
  {
    id: 'v012',
    title: '歌声飞扬',
    cover: 'https://readdy.ai/api/search-image?query=A%20music%20competition%20show%20poster%2C%20stage%20with%20colorful%20spotlights%2C%20microphone%20in%20spotlight%2C%20concert%20atmosphere%2C%20glamorous%20entertainment%20photography%2C%20vibrant%20energy&width=600&height=800&seq=video-cover-012&orientation=portrait',
    category: 'zongyi',
    tags: ['音乐', '竞技', '真人秀'],
    duration: '1:32:45',
    quality: '1080P',
    views: 213400,
    rating: 8.6,
    description: '年度最火爆音乐竞技综艺！来自全国各地的实力唱将同台竞技，用歌声传递情感与力量。导师阵容豪华，赛制紧张刺激，每一期都是听觉盛宴。',
    releaseDate: '2026-07-19',
    source: '糖心视频',
  },
];